// The one look of "a cooperation opened" — a cyan diamond with a dark edge (owner 2026-11-03: "bright green or
// blue … different than these platforms colors"). Cyan sits between SS blue and MyHome green, so it wears a dark
// outline. The Activity tab's rail, its day counter and the Desk ranking row all draw it from here, so the same
// thing never wears two signs.
export const COOP_FILL = '#22d3ee'
export const COOP_EDGE = '#0e7490'
